import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { Actions, ofType } from '@ngrx/effects';

import { PHONE_NUMBER_REGEX } from '@core/constants/regex';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

import { Store } from '@ngrx/store';
import { AppState } from '@state/app.state';
import {
  setAuthModal,
  setLoadingAction,
  updatePhoneNumberAction,
  updatePhoneNumberActionFailure,
} from '@state/auth/auth.actions';
import {
  selectAuthUser,
  selectAuthLoading,
  selectUpdatePhoneNumberSuccess,
} from '@state/auth/auth.selectors';

@UntilDestroy()
@Component({
  selector: 'app-auth-add-phone-number',
  templateUrl: './add-phone-number.component.html',
  styleUrls: ['./add-phone-number.component.scss'],
})
export class AddPhoneNumberComponent implements OnInit {
  protected loading$ = this.store.select(selectAuthLoading);
  protected focused = false;
  protected userName = '';

  public addPhoneNumberForm = this.formBuilder.group({
    phoneNumber: new FormControl('', [
      Validators.required,
      Validators.pattern(PHONE_NUMBER_REGEX),
    ]),
  });

  constructor(
    private store: Store<AppState>,
    private formBuilder: FormBuilder,
    private actions$: Actions
  ) {}

  ngOnInit(): void {
    this.store
      .select(selectAuthUser)
      .pipe(untilDestroyed(this))
      .subscribe((user) => {
        this.userName = user?.firstName + ' ' + user?.surname;
      });

    this.actions$
      .pipe(ofType(updatePhoneNumberActionFailure), untilDestroyed(this))
      .subscribe((errors) => {
        errors.errors.forEach((error) => {
          if (error.message === 'has already been taken') {
            this.addPhoneNumberForm.controls['phoneNumber'].setErrors({
              server: 'Phone number has already been taken',
            });
          }
        });
      });
  }

  submitHandler(): void {
    if (this.addPhoneNumberForm.invalid) {
      this.addPhoneNumberForm.markAllAsTouched();
      return;
    }
    const phoneNumber = this.addPhoneNumberForm.value.phoneNumber;
    this.store.dispatch(setLoadingAction({ loading: true }));
    this.store.dispatch(
      updatePhoneNumberAction({ input: { phoneNumber: '+1' + phoneNumber } })
    );
    this.store
      .select(selectUpdatePhoneNumberSuccess)
      .pipe(untilDestroyed(this))
      .subscribe((success) => {
        if (success) {
          this.store.dispatch(setAuthModal({ authModal: 'verify-identity' }));
        }
      });
  }

  pastePhoneNumberHandler(event: ClipboardEvent) {
    const pastedText = event.clipboardData
      ?.getData('text/plain')
      .replace(/[\s()-]/g, '');
    setTimeout(() => {
      if (pastedText?.startsWith('+1')) {
        this.addPhoneNumberForm.controls['phoneNumber'].setValue(
          pastedText?.substring(2, pastedText.length)
        );
      }
    }, 0);
  }
}
